import styled from 'styled-components';

const RegularLayout = styled.div`
  padding: 2rem;
  width: 100%;
  max-width: 860px;
  height: 100%;
`;

export default RegularLayout;
